import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Optional } from '@honda-canada/design-system-react';
import UniCard from '../../UniCard';
import themeStyles from './ProductCard.style';
import uniCardThemeStyles from '../../UniCard/styles/Card.styles';
import useHoverState from '../../ModelCardGrid/useHoverState';
import { EqualHeightElement } from '../../../utils/components/EqualHeight';
import { useAppSelector } from '../../../core/utils';
import { selectPrimaryCalculatorPaymentOptions } from '../../../core/reducers/financialCalculators';
import useFetchTrimPayment from '../../../core/apiHooks/useFetchTrimPayment';
const UniCardWrapper = uniCardThemeStyles.apply(Box, 'UniCardWrapper');
const ProductCardContainer = themeStyles.apply(Box, 'ProductCardContainer');
const ProductCard = ({ product, handleSelectTrim, isSelected }) => {
    var _a, _b, _c;
    const productYear = product === null || product === void 0 ? void 0 : product.modelYear;
    const trimName = (_a = product === null || product === void 0 ? void 0 : product.trimName) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    const productPrimaryThumbnail = (_b = product === null || product === void 0 ? void 0 : product.trimImage) === null || _b === void 0 ? void 0 : _b.primaryThumbnail;
    const productSecondaryThumbnail = (_c = product === null || product === void 0 ? void 0 : product.trimImage) === null || _c === void 0 ? void 0 : _c.secondaryThumbnail;
    const { thumbnail, backgroundColor, onMouseEnter, onMouseLeave } = useHoverState({
        primaryThumbnail: productPrimaryThumbnail,
        secondaryThumbnail: productSecondaryThumbnail,
    });
    const paymentOptions = useAppSelector(selectPrimaryCalculatorPaymentOptions);
    const payment = useFetchTrimPayment(product.trimKey, paymentOptions);
    const paymentTooltip = {
        year: productYear,
        model: product.modelName || '',
        trim: product.trimName || '',
    };
    const cardEvents = {
        onMouseEnter,
        onMouseLeave,
    };
    const onHoverBackgroundColor = backgroundColor;
    return (_jsx(ProductCardContainer, { isSelected: isSelected, children: _jsx(UniCardWrapper, { variant: "hasShadow", "data-testid": "cy-uni-card", onClick: () => handleSelectTrim(product), children: _jsxs(UniCard, { onHoverBackgroundColor: onHoverBackgroundColor, events: cardEvents, children: [_jsx(UniCard.TitleWrapper, { children: _jsx(UniCard.Title, { title: `${productYear} ${trimName}`, styles: {
                                minHeight: '56px',
                            } }) }), _jsx(EqualHeightElement, { name: "CardPricing", children: _jsx(UniCard.Pricing, { ...payment }) }), _jsx(UniCard.Image, { src: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.src, alt: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.alt }), _jsx(EqualHeightElement, { name: "CardPayment", placeholder: !product.trimKey, children: _jsx(Optional, { when: product.trimKey, children: _jsx(UniCard.PaymentDetails, { paymentTooltip: paymentTooltip, payment: payment }) }) })] }) }) }));
};
export default ProductCard;
